<template>
  <div>
    <h1>测试页面</h1>
    <img :src="img" title="快点我" style="width: 100px; height: 100px" @click="uploadImage()" />
    <el-button @click="uploadImage()">上传图片</el-button>
    <el-button @click="testDoing()">$doing()</el-button>
    <el-button @click="$toast($t('你好'))">$toast()</el-button>
    <el-button @click="$toast($t('你好'), 'success')">$toast2()</el-button>
    <el-button @click="$toast($t('你好'), 'error')">$toast3()</el-button>
    <el-button @click="testQuery()">$query()</el-button>
    <el-button @click="$msg('Hello World!')">$msg()</el-button>
    <el-button @click="++count">{{
      $t("翻译测试，您点击了{0}次！", count)
    }}</el-button>
    <el-button @click="++count">{{
      $t("翻译测试，您点击了{0}次！").replace("{0}", count)
    }}</el-button>
    <el-button @click="++count">{{ $t("翻译测试，您点击了") }}{{ count }}{{ $t("次!") }}</el-button>
    <el-button @click="handleClick">我是一个按钮</el-button>
    <div class="box"></div>
    <el-button @click="getMapCenter">获取地图中心</el-button>
    <el-button @click="addMapMarker">添加地图标记</el-button>
    <el-button @click="clearMapMarker">清空地图标记</el-button>
    <span>{{ mapCenter }}</span>
    <IRMap ref="mapView" @mounted="mapMounted" style="width:600px;height:300px;"></IRMap>
    <img src="" @error="setDefaultImage" />
  </div>
</template>
<script>
import IRMap from '@/components/base/IRMap'
export default {
  data() {
    return {
      img: "",
      mapCenter: "",
      count: 0,

    };
  },
  components: { IRMap },
  methods: {
    setDefaultImage(e) {
      e.target.src = require('@/assets/image/banner.png')
    },
    async uploadImage() {
      let r = await this.$uploadImage();
      if (r) {
        this.img = r.url;
      }
    },
    testDoing() {
      this.$doing("哈哈哈哈...");
      setTimeout(() => {
        this.$done();
      }, 2000);
    },
    async testQuery() {
      let r = await this.$query("确定要执行下一步吗？");
      this.$msg("你的选择:" + r);
    },
    handleClick() { },
    getMapCenter() {
      let ct = this.$refs.mapView.map.getCenter()
      console.log(ct)
      alert(JSON.stringify(ct))
    },
    addMapMarker() {
      let ct = this.$refs.mapView.map.getCenter()
      this.$refs.mapView.map.addMarker(ct[0], ct[1])
    },
    clearMapMarker() {
      this.$refs.mapView.map.clearMarkers()
    },
    mapMounted() {
      //地图组件挂载成功
      let map = this.$refs.mapView.map;
      console.log("地图书初始化完成", this.$refs.mapView.map)
      map.addEventListener("click", ({ lat, lng }) => {
        console.log("click", lng, lat)
        // map.clearMarkers()
        map.addMarker(lng, lat)
      })
    }
  },
};
</script>
<style lang="scss">
@import "@/style/theme.scss";

.home {
  height: 500px;
  background: $main-color;
}
</style>
